import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LeadList } from "./LeadList";
import { AdditionalInfoModal } from "./AdditionalInfoModal";
import { useDesktopMode } from "rc-app/hooks/useDesktopMode";
import DesktopModePrompt from "rc-app/components/DesktopModePrompt";

interface Lead {
  id: string;
  status: "hot" | "warm" | "cold" | "customer" | "denied" | "";
  fullName: string;
  mobile: string;
  email: string;
  lastUpdate?: string;
  interestedIn?: string;
  city?: string;
  profileStatus?: string;
  linkedIn?: string;
  addressLine1?: string;
  addressLine2?: string;
  landmark?: string;
  pincode?: string;
  state?: string;
  referredBy?: string;
  investmentType?: string;
  annualIncome?: string;
  budget?: string;
  occupationType?: string;
  incomeSource?: string;
  familySize?: string;
}

export const Leads: React.FC = () => {
  const navigate = useNavigate();
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  const [showModal, setShowModal] = useState(false);
  const { showPrompt, accept, dismiss } = useDesktopMode();


  const handleMoreInfo = (lead: Lead) => {
    setSelectedLead(lead);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedLead(null);
  };

  if (showPrompt) {
    return (
      <DesktopModePrompt
        message="This page contains lead management tables and data that are best viewed in desktop mode. Switch to desktop view for the best experience."
        onAccept={accept}
        onGoBack={() => { dismiss(); navigate("/"); }}
      />
    );
  }

  return (
    <div className="h-full bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] p-3 sm:p-4 md:p-6">
      <LeadList onMoreInfo={handleMoreInfo} />
      {showModal && selectedLead && (
        <AdditionalInfoModal lead={selectedLead} onClose={handleCloseModal} />
      )}
    </div>
  );
};
